import React from 'react'
import "./Basket.scss"

function Basket() {
  return (
    <div>Basket</div>
  )
}

export default Basket